import { createAction, handleActions } from 'redux-actions';
import { _getPetSizesList, _editPetSize } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';

const initialState = {
  pet_sizes: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },
  edit_pet_size: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },
};

export const getPetSizesListStart = createAction(ActionTypes.GET_PET_SIZES_LIST);
export const getPetSizesListSuccess = createAction(ActionTypes.GET_PET_SIZES_LIST_SUCCESS, response => response);
export const getPetSizesListError = createAction(ActionTypes.GET_PET_SIZES_LIST_ERROR, error => error);

export const getPetSizesList = (petId) => (dispatch) => {
  dispatch(getPetSizesListStart());
  return _getPetSizesList(petId).then((response) => {
    dispatch(getPetSizesListSuccess(response));
  }).catch((error) => {
    dispatch(getPetSizesListError(error));
  });
};

export const editPetSizeStart = createAction(ActionTypes.EDIT_PET_SIZE);
export const editPetSizeSuccess = createAction(ActionTypes.EDIT_PET_SIZE_SUCCESS, response => response);
export const editPetSizeError = createAction(ActionTypes.EDIT_PET_SIZE_ERROR, error => error);

export const editPetSize = (id, data) => (dispatch) => {
  dispatch(editPetSizeStart());
  return _editPetSize(id, data).then((response) => {
    dispatch(editPetSizeSuccess(response));
  }).catch((error) => {
    dispatch(editPetSizeError(error));
  });
};


const reducer = handleActions({
  //PET_SIZES_LIST
  [ActionTypes.GET_PET_SIZES_LIST]: (state) => ({
    ...state, pet_sizes: {
      ...state.pet_sizes,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_PET_SIZES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    pet_sizes: {
      ...state.pet_sizes,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_PET_SIZES_LIST_ERROR]: (state, action) => ({
    ...state,
    pet_sizes: {
      ...state.pet_sizes,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //EDIT_PET_SIZE
  [ActionTypes.EDIT_PET_SIZE]: (state) => ({
    ...state, edit_pet_size: {
      ...state.edit_pet_size,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_PET_SIZE_SUCCESS]: (state, action) => ({
    ...state,
    edit_pet_size: {
      ...state.edit_pet_size,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_PET_SIZE_ERROR]: (state, action) => ({
    ...state,
    edit_pet_size: {
      ...state.edit_pet_size,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
}, initialState);

export default reducer;